import { ResumeFunnelButton } from '@hungryroot/funnel';
import { islandRoot } from '../IslandRoot/IslandRoot';

export const ResumeQuizButtonWrapperIsland = islandRoot(ResumeFunnelButton);
